import React from "react";
import {
  Accordion
} from "react-bootstrap";

import SectionContainer from "../common/SectionContainer";
import SectionTitle from "../common/SectionTitle";
import faqs from "../../data/faqs";


function FAQSection() {
  return (
    <SectionContainer background="#f8fafc">
      <SectionTitle
        title="Frequently Asked Questions"
      />

      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto"
        }}
      >
        <Accordion>
          {faqs.map((faq, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
            >
              <Accordion.Header>
                {faq.question}
              </Accordion.Header>

              <Accordion.Body>
                {faq.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </SectionContainer>
  );
}

export default FAQSection;